import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, switchMap, filter, take, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { nvlObj, nvlString } from 'src/app/core/services/utils.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

    private refreshTokenInProgress = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(public authService: AuthService, private toast: ToastrService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {

        return next.handle(this.checkToken(request)).pipe(

            // HTTP 200 responses
            // tap((event: any) => { 
            //     if (nvlObj(event).body) {
            //         const body = nvlObj(event.body);
            //         if (body.success === false && body.code === 500) {
            //             this.toast.error('Something went wrong while processing your request. Please try again or contact support.');
            //         }
            //     }
            // }),
            // HTTP Error responses
            catchError((err: HttpErrorResponse) => {
                const error = nvlObj(err);

                const tErrStr: any = nvlString(error.error.error);
                if (tErrStr.includes('Unexpected token') || tErrStr.includes('Invalid token')) {
                    this.toast.error(
                        'Token expired. Please Login again.',
                        'Authentication Failure'
                    );
                }

                if (error.status === 0) {
                    this.toast.error(
                        'The server is currently unavailable. Please try again later.',
                        'Service Unreachable'
                    );
                    return throwError(() => ({
                        code: 503,
                        message: 'Service unavailable',
                        original: error
                    }));
                }

                if (error.status === 500) {
                    this.toast.error('Something went wrong while processing your request. Please try again or contact with support.');
                }

                if (request.url.includes("refreshtoken") || request.url.includes("oauth/token")) {
                    if (request.url.includes("refreshtoken")) {
                        this.authService.logout();
                    }
                    return throwError(error);
                }

                if (error.status !== 401) {
                    return throwError(error);
                }

                if (this.refreshTokenInProgress) {
                    return this.refreshTokenSubject.pipe(
                        filter(result => result !== null),
                        take(1),
                        switchMap(() => next.handle(this.checkToken(request)))
                    );
                } else {
                    this.refreshTokenInProgress = true;
                    this.refreshTokenSubject.next(null);
                    return this.authService
                        .refreshAccessToken().pipe(
                            switchMap((token: any) => {
                                this.refreshTokenInProgress = false;
                                this.refreshTokenSubject.next(token);
                                return next.handle(this.checkToken(request));
                            }),
                            catchError(() => {
                                this.refreshTokenInProgress = false;
                                this.authService.logout();
                                return throwError(error);
                            })
                        )
                }
            })
        );
    }

    public checkToken(request: any) {
        return request.clone({ withCredentials: true });
    }
}
